import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { cleanRoom } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from 'react-query';
import { useState } from 'react';


export const useCleanRoomJobRunsMetrics = (crId, jobType) => {
  const dispatch = useDispatch();
  const { ID: orgId } = useSelector(activeOrgSelector);
  const [data, setData] = useState({
    running: 0,
    queued: 0,
    errors: 0,
    completed: 0,
  });

  const {
    isLoading, isError, isSuccess, isFetching,
  } = useQuery(
    ['CleanRoomJobRunsMetrics', { orgId, crId, jobType }],
    () => axiosInstance.get(cleanRoom(orgId).cleanRoomJobRunsMetrics(crId, jobType)),
    {
      onSuccess: (res) => res.data && setData(res.data),
      onError: (err) => {
        const errorMessage = err?.response?.data?.message || 'Failed to fetch run summary metrics';
        dispatch(showAlert({ message: errorMessage, type: 'error' }));
      },
    });

  return {
    isLoading,
    isError,
    isSuccess,
    data,
    isFetching,
  };
};
